import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=fb4f97e4&scoped=true"
import script from "./Write.vue?vue&type=script&lang=ts"
export * from "./Write.vue?vue&type=script&lang=ts"
import style0 from "./Write.vue?vue&type=style&index=0&id=fb4f97e4&prod&lang=scss"
import style1 from "./Write.vue?vue&type=style&index=1&id=fb4f97e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4f97e4",
  null
  
)

export default component.exports